import axios from "../../axiosConfig";
import { put, call } from "redux-saga/effects";
import { TOAST_SHOW } from "../Actions/ToastAction";
import {
  CREATE_EXPLORE_SUCCESS,
  CREATE_EXPLORE_FAILED,
  GET_EXPLORE_SUCCESS,
  GET_EXPLORE_FAILED,
  UPDATE_EXPLORE_SUCCESS,
  UPDATE_EXPLORE_FAILED,
  PUBLISHED_EXPLORE_STATUS_SUCCESS,
  PUBLISHED_EXPLORE_STATUS_FAILED,
  SEARCH_EXPLORE_SUCCESS,
  SEARCH_EXPLORE_FAILED,
  GET_EXPLORE_CATEGORY_SUCCESS,
  GET_EXPLORE_CATEGORY_FAILED,
  CREATE_EXPLORE_CATEGORY_SUCCESS,
  CREATE_EXPLORE_CATEGORY_FAILED,
  UPDATE_EXPLORE_CATEGORY_SUCCESS,
  UPDATE_EXPLORE_CATEGORY_FAILED,
  DRAFT_EXPLORE_ACTIVE_STATUS_SUCCESS,
  DRAFT_EXPLORE_ACTIVE_STATUS_FAILED,
  ACTIVE_EXPLORE_CATEGORY_SUCCESS,
  ACTIVE_EXPLORE_CATEGORY_FAILED,
  REMOVE_EXPLORE_FAILED,
  REMOVE_EXPLORE_SUCCESS,
  REMOVE_CATEGORY_SUCCESS,
  REMOVE_CATEGORY_FAILED,

  REORDER_CONTENT_FAILED,
  REORDER_CONTENT_SUCCESS,
  COPY_CONTENT_SUCCESS,
  COPY_CONTENT_FAILED,
} from "../Actions/ExploreAction";
import decryptResponse from "../../Components/Decrypt";

export function* createExploreSaga(action) {
  try {
    const response = yield call(axios.post, `/create-explore`, action?.payload);
    const { success, data, message, errors } = response?.data;
    yield put({ type: CREATE_EXPLORE_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: CREATE_EXPLORE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* getExploreSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-explore-details-by-Id/${action.payload}`
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_EXPLORE_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_EXPLORE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* updateExploreSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/edit-explore-details`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: UPDATE_EXPLORE_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: UPDATE_EXPLORE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* publishedExploreSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/change-explore-status`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({
      type: PUBLISHED_EXPLORE_STATUS_SUCCESS,
      payload: action.payload,
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: PUBLISHED_EXPLORE_STATUS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* exploreSearchSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-search-explore-details`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: SEARCH_EXPLORE_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: SEARCH_EXPLORE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* getExploreCategorySaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-search-category-details`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_EXPLORE_CATEGORY_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_EXPLORE_CATEGORY_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* createExploreCategorySaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/create-category`,
      action?.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: CREATE_EXPLORE_CATEGORY_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: CREATE_EXPLORE_CATEGORY_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* updateExploreCategorySaga(action) {
  try {
    const response = yield call(
      axios.patch,
      `/update-category-status-by-Id`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: UPDATE_EXPLORE_CATEGORY_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: UPDATE_EXPLORE_CATEGORY_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* draftExploreActiveSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/change-explore-active-status`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: DRAFT_EXPLORE_ACTIVE_STATUS_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: DRAFT_EXPLORE_ACTIVE_STATUS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* activeExploreCategorySaga(action) {
  try {
    const response = yield call(axios.get, `/get-categories`);
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: ACTIVE_EXPLORE_CATEGORY_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: ACTIVE_EXPLORE_CATEGORY_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* RemoveExploreSaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `delete-explore-details/${action?.payload?.Id}`
    );
    const { message } = response?.data;
    yield put({ type: REMOVE_EXPLORE_SUCCESS, payload: action?.payload?.Id });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: REMOVE_EXPLORE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* RemoveCategorySaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `delete-category/${action?.payload?.Id}`
    );
    const { message } = response?.data;
    yield put({ type: REMOVE_CATEGORY_SUCCESS, payload: action?.payload?.Id });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: REMOVE_CATEGORY_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* ReOrderContentSaga(action) {
  try {
    const response = yield call(axios.post, `/re-order-explore-content`, action.payload);
    const { data, message } = response?.data;
    yield put({ type: REORDER_CONTENT_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: REORDER_CONTENT_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* copyContentSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/duplicate-content`,
      action.payload
    );

    yield put({
      type: COPY_CONTENT_SUCCESS,
    });
  } catch (e) {
    yield put({ type: COPY_CONTENT_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
